<template>
  <v-card class="pa-4" flat>
    <!-- حالت نمایش فرم -->
    <template v-if="showForm && !editDesign">
      <v-card-title class="d-flex align-center mb-4">
        <v-btn @click="backToList" class="mr-2 btn-delete rounded-lg">
          <v-icon>mdi-arrow-right</v-icon>
          بازگشت
        </v-btn>
        <v-icon left small class="px-2"> {{ formicon }}</v-icon>
        <span class="text-h5">{{ formTitle }}</span>
        <v-spacer />
      </v-card-title>

      <personal-assistant-builder
        :assistant-data="editingAssistant"
        @save="handleSaveAssistant"
        @cancel="backToList"
      />
    </template>

    <!-- حالت نمایش لیست -->
    <template v-if="!showForm && !editDesign">
      <v-alert
        class="rounded-lg mb-4"
        border="left"
        color="#F7B2B2FF"
        v-if="
          assistants.data !== null &&
          assistants.data !== undefined &&
          assistants.data !== '[]'
        "
        type="info"
      >
        شما می‌توانید فقط یک دستیار را به صورت آزمایشی و یکروزه تست کنید. برای
        استفاده نامحدود، لطفاً اشتراک تهیه کنید.
      </v-alert>
      <v-col cols="12" class="pa-0 mb-4 d-flex justify-end">
        <v-btn
          @click="addAssistant"
          class="rounded-lg mb2 btn-get-code"
          style="letter-spacing: normal"
        >
          افزودن دستیار جدید
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-col>

      <v-progress-linear v-show="loading" class="mb-2" indeterminate />

      <vue-table
        :data="assistants"
        :headers="headers"
        :loading.sync="loading"
        @change="onPagination"
      >
        <template v-slot:filters="{ props, perPage }">
          <v-row no-gutters>
            <v-col class="pa-2" cols="12" lg="2" md="3">
              <v-select
                v-model="props.length"
                :items="perPage"
                class="rounded-lg"
                dense
                hide-details
                label="تعداد در هر صفحه"
                outlined
                @change="onPagination"
              />
            </v-col>
            <v-col class="pa-2" cols="12" lg="3" md="4">
              <v-text-field
                v-model="props.search"
                append-icon="mdi-magnify"
                class="rounded-lg"
                clearable
                dense
                label="جستجو"
                outlined
              >
                <template v-slot:append>
                  <v-icon
                    @click="applySearch"
                    class="cursor-pointer"
                    color="primary"
                  >
                    mdi-magnify
                  </v-icon>
                </template>
              </v-text-field>
            </v-col>
            <v-col class="pa-2" cols="12" lg="2" md="3">
              <v-select
                v-model="props.column"
                :items="columnOptions"
                label="مرتب سازی بر اساس"
                dense
                outlined
                class="rounded-lg"
              />
            </v-col>
            <v-col class="pa-2" cols="12" lg="2" md="3">
              <v-select
                v-model="props.dir"
                :items="dirOptions"
                label="جهت مرتب سازی"
                dense
                outlined
                class="rounded-lg"
              />
            </v-col>
            <v-col class="pa-2" cols="12" lg="2" md="3">
              <v-select
                v-model="props.type"
                :items="typeOptions"
                dense
                label="نوع دستیار"
                hide-details
                outlined
                class="rounded-lg"
              />
            </v-col>
            <v-col class="pa-2 d-flex justify-end" cols="12" lg="12" md="12">
              <v-btn
                class="rounded-lg mb2 btn-delete"
                outlined
                @click="resetfilter()"
              >
                حذف فیلتر <v-icon class="px-2" small>mdi-trash-can</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </template>
        <template v-slot:index="{ item }">
          {{
            item.index + 1 + (assistants.current_page - 1) * assistants.per_page
          }}
        </template>

        <template v-slot:name="{ item }">
          {{ item.name || "--" }}
        </template>
        <template v-slot:type="{ item }">
          {{ item.type || "--" }}
        </template>
        <template v-slot:expired_at="{ item }"
          >{{
            item.expired_at === null
              ? "طرحی فعال نشده"
              : jalalian(item.expired_at)
          }}
        </template>
        <template v-slot:expired_status="{ item }">
          <v-chip
            :color="getStatusColor(item.expired_at)"
            :text-color="getStatusTextColor(item.expired_at)"
            small
          >
            {{ getStatusText(item.expired_at) }}
          </v-chip>
        </template>
        <template v-slot:action="{ item }">
          <manage-button :data="item" :meta="metaButtons" />
        </template>
      </vue-table>
    </template>
    <assistant-chat-tester
      v-if="selectedAssistantId"
      :assistant-id="selectedAssistantId"
      :assistant-data="selectedAssistantData"
      :closerobot="showRobot"
    />
    <upgrade-ai
      v-model="showUpgradeDialog"
      :current-package="currentPackage"
      @input="showUpgradeDialog = $event"
      :assistant-id="selectedAssistantId"
    />
    <v-dialog
      v-model="showlink"
      max-width="550"
      overlay-color="#0a121e"
      overlay-opacity="0.9"
    >
      <v-card class="rounded-xl overflow-hidden shadow-2xl">
        <v-card-title
          class="pa-6 d-flex justify-space-between align-center border-b"
        >
          <div class="d-flex align-center">
            <v-avatar color="primary lighten-5" size="40" class="mr-3">
              <v-icon color="primary">mdi-link-variant</v-icon>
            </v-avatar>
            <div>
              <span class="text-h6 font-weight-bold secondary--text"
                >اشتراک‌گذاری دستیار</span
              >
              <div class="text-caption grey--text text--darken-1">
                لینک‌های زیر را برای دسترسی کاربران کپی کنید
              </div>
            </div>
          </div>
          <v-btn icon @click="showlink = false" class="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-6">
          <div class="link-container mb-6">
            <div class="d-flex align-center mb-2">
              <v-icon x-small color="primary" class="mr-1">mdi-flash</v-icon>
              <span class="text-subtitle-2 font-weight-bold"
                >لینک سریع (کوتاه شده)</span
              >
            </div>
            <div class="link-box d-flex align-center">
              <div
                class="link-text text-truncate direction-ltr px-4 py-3 flex-grow-1"
              >
                {{ selectedAssistantData?.link ?? "در حال تولید لینک..." }}
              </div>
              <v-tooltip bottom content-class="rounded-lg">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    depressed
                    class="ma-1 btn-download rounded-pill"
                    @click="copyToClipboard(selectedAssistantData?.link)"
                  >
                    <v-icon small>mdi-content-copy</v-icon>
                    <span class="mr-1"></span>
                  </v-btn>
                </template>
                <span>کپی لینک کوتاه</span>
              </v-tooltip>
            </div>
          </div>

          <div class="link-container">
            <div class="d-flex align-center mb-2">
              <v-icon x-small color="secondary" class="mr-1">mdi-web</v-icon>
              <span class="text-subtitle-2 font-weight-bold"
                >لینک مستقیم چت (Full URL)</span
              >
            </div>
            <div class="link-box d-flex align-center">
              <div
                class="link-text text-truncate direction-ltr px-4 py-3 flex-grow-1"
              >
                {{
                  selectedAssistantData?.uniq_key
                    ? `https://core-ai.terminalads.com/#/assistantchat/${selectedAssistantData.uniq_key}`
                    : "در حال تولید لینک..."
                }}
              </div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="ma-1 btn-download rounded-pill"
                    @click="
                      copyToClipboard(
                        `https://core-ai.terminalads.com/#/assistantchat/${selectedAssistantData?.uniq_key}`,
                      )
                    "
                  >
                    <v-icon small>mdi-content-copy</v-icon>
                  </v-btn>
                </template>
                <span>کپی لینک کامل</span>
              </v-tooltip>
            </div>
          </div>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="pa-4 bg-grey lighten-5">
          <v-icon color="orange" small class="mx-2"
            >mdi-information-outline</v-icon
          >
          <span class="caption grey--text text--darken-2">
            لینک مستقیم برای استفاده در دکمه‌های سایت یا بایو اینستاگرام مناسب
            است.
          </span>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- <setting-layout
      v-if="editDesign"
      :assistant-id="selectedAssistantId"
      :design-data="selecteddesign"
      @back="editDesign = false"
    /> -->
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import personalAssistantBuilder from "./personalAssistantBuilder.vue";
import ManageButton from "./manageButton.vue";
import AssistantChatTester from "./assistantChatTester.vue";
import UpgradeAi from "./upgradeAi.vue";
// import settingLayout from "./settingLayout.vue";

export default {
  name: "AssistantAi",
  components: {
    personalAssistantBuilder,
    ManageButton,
    AssistantChatTester,
    UpgradeAi,
    // settingLayout,
  },

  props: {
    value: Boolean,
  },

  data() {
    return {
      showlink: false,
      editDesign: false,
      localSearch: "",
      showRobot: false,
      assistants: [],
      tableProps: {
        search: "",
        length: 10,
        column: "id",
        dir: "desc",
        page: 1,
      },
      loading: false,
      showForm: false,
      editingAssistant: null,
      deletingAssistant: null,
      selectedAssistantId: null,
      selectedAssistantData: null,
      selecteddesign: null,
      showUpgradeDialog: false,
      currentPackage: null,

      columnOptions: [
        { text: "نام", value: "name" },
        { text: "نوع", value: "type" },
        { text: "تاریخ انقضا", value: "expired_at" },
      ],
      dirOptions: [
        { text: "نزولی", value: "desc" },
        { text: "صعودی", value: "asc" },
      ],
      typeOptions: [
        { text: "دستیار فروش", value: "دستیار فروش" },
        { text: "دستیار پشتیبانی", value: "دستیار پشتیبانی" },
        { text: "دستیار راهنما", value: "دستیار راهنما" },
        { text: "دستیار مشاور", value: "دستیار مشاور" },
        { text: "دستیار اختصاصی برند", value: "دستیار اختصاصی برند" },
        {
          text: "دستیار پاسخ‌گوی واتساپ/دایرکت",
          value: "دستیار پاسخ‌گوی واتساپ/دایرکت",
        },
        { text: "دستیار پاسخ‌گوی سایت", value: "دستیار پاسخ‌گوی سایت" },
        { text: "دستیار پاسخ‌گوی تلفنی", value: "دستیار پاسخ‌گوی تلفنی" },
        { text: "دستیار آموزش محصول", value: "دستیار آموزش محصول" },
        { text: "دستیار پیگیری سفارش", value: "دستیار پیگیری سفارش" },
        { text: "دستیار قبل از خرید", value: "دستیار قبل از خرید" },
        { text: "دستیار بعد از خرید", value: "دستیار بعد از خرید" },
        { text: "دستیار سازمانی (B2B)", value: "دستیار سازمانی (B2B)" },
        { text: "دستیار نمایندگی‌ها", value: "دستیار نمایندگی‌ها" },
        { text: "دستیار خدمات پس از فروش", value: "دستیار خدمات پس از فروش" },
        {
          text: "دستیار ثبت شکایت و بازخورد",
          value: "دستیار ثبت شکایت و بازخورد",
        },
        {
          text: "دستیار محتوای محصول (FAQ ساز)",
          value: "دستیار محتوای محصول (FAQ ساز)",
        },
        {
          text: "دستیار مقایسه و انتخاب محصول",
          value: "دستیار مقایسه و انتخاب محصول",
        },
      ],
      metaButtons: {
        buttons: [
          {
            name: "view",
            label: "پیش نمایش",
            icon: "eye",
            class: "btn-show border-2 rounded-pill",
            action: this.action,
          },
          {
            name: "delete",
            label: "حذف",
            icon: "trash-can",
            class: "btn-refund border-2 rounded-pill",
            action: this.action,
          },
          {
            name: "edit",
            label: "ویرایش دستیار",
            icon: "pencil",
            class: "btn-edit border-2 rounded-pill",
            action: this.action,
          },
          {
            name: "edit_design",
            label: "ویرایش دیزاین",
            icon: "pencil-ruler",
            class: "btn-success border-2 rounded-pill",
            action: this.action,
          },
          {
            name: "connection",
            label: "اتصال لینک",
            icon: "lan-connect",
            class: "btn-primary border-2 rounded-pill",
            action: this.action,
          },
          {
            name: "disconnect",
            label: "قطع لینک",
            icon: "lan-disconnect",
            class: "btn-warning border-2 rounded-pill",
            action: this.action,
          },
          {
            name: "buy",
            label: "تمدید",
            icon: "autorenew",
            class: "btn-buy border-2 rounded-pill",
            action: this.action,
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters("ribbon", ["user"]),

    formTitle() {
      return this.editingAssistant
        ? "ویرایش دستیار شخصی سازی شده"
        : "ساخت دستیار شخصی سازی شده";
    },
    formicon() {
      return this.editingAssistant ? "mdi-pencil-outline" : "mdi-plus";
    },
    headers() {
      return [
        {
          value: "index",
          text: "ردیف",
          align: "center",
          sortable: false,
        },
        {
          value: "name",
          text: "نام",
          align: "center",
          sortable: true,
        },
        {
          value: "type",
          text: "نوع دستیار",
          align: "center",
          sortable: true,
        },
        {
          value: "expired_at",
          text: "تاریخ انقضا",
          align: "center",
          sortable: true,
        },
        {
          value: "expired_status",
          text: "وضعیت",
          align: "center",
          sortable: true,
        },
        {
          value: "action",
          text: "عملیات",
          align: "center",
          sortable: false,
        },
      ];
    },
  },

  watch: {
    showUpgradeDialog(newVal) {
      if (!newVal) {
        this.$nextTick(() => {
          this.fetch();
        });
      }
    },
    showForm(newVal) {
      if (!newVal) {
        this.$nextTick(() => {
          window.scrollTo({ top: 0, behavior: "smooth" });
          this.fetch();
        });
      }
    },
    value(val) {
      if (val) {
        setTimeout(() => {
          this.fetch();
        }, 300);
      }
    },
  },

  mounted() {
    this.fetch();
  },

  methods: {
    copyToClipboard(text) {
      if (!text) {
        this.$toast.warning("لینکی برای کپی وجود ندارد");
        return;
      }
      navigator.clipboard.writeText(text).then(() => {
        this.$toast.success("لینک با موفقیت کپی شد", {
          position: "bottom-center",
          timeout: 2000,
        });
      });
    },
    getStatusColor(expiredAt) {
      if (!expiredAt) return "#033";
      const expiredDate = new Date(expiredAt);
      const now = new Date();
      const diffTime = expiredDate - now;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if (diffDays < 0) {
        // منقضی شده
        return "#f21";
      } else if (diffDays <= 7) {
        return "#f51";
      } else if (diffDays <= 15) {
        return "#ff4";
      } else {
        return "#0f1";
      }
    },

    getStatusTextColor(expiredAt) {
      if (!expiredAt) return "white";

      const expiredDate = new Date(expiredAt);
      const now = new Date();
      const diffTime = expiredDate - now;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if (diffDays < 0) {
        // منقضی شده - متن سفید
        return "white";
      } else if (diffDays <= 7) {
        // زیر یک هفته - متن تیره
        return "black";
      } else {
        // زمان زیادی - متن سفید
        return "white";
      }
    },

    getStatusText(expiredAt) {
      if (!expiredAt) return "فاقد طرح";

      const expiredDate = new Date(expiredAt);
      const now = new Date();
      const diffTime = expiredDate - now;

      if (diffTime < 0) {
        const absDiff = Math.abs(diffTime);
        const days = Math.floor(absDiff / (1000 * 60 * 60 * 24));
        if (days > 0) {
          return `${days} روز گذشته`;
        } else {
          const hours = Math.floor(absDiff / (1000 * 60 * 60));
          if (hours > 0) {
            return `${hours} ساعت گذشته`;
          } else {
            const minutes = Math.floor(absDiff / (1000 * 60));
            return `${minutes} دقیقه گذشته`;
          }
        }
      }

      const days = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      if (days > 1) {
        return `${days} روز باقی‌مانده`;
      } else if (days === 1) {
        const hours = Math.floor(diffTime / (1000 * 60 * 60));
        if (hours < 24) {
          return `${hours} ساعت باقی‌مانده`;
        } else {
          return "۱ روز باقی‌مانده";
        }
      } else {
        const hours = Math.floor(diffTime / (1000 * 60 * 60));
        if (hours > 0) {
          return `${hours} ساعت باقی‌مانده`;
        } else {
          const minutes = Math.floor(diffTime / (1000 * 60));
          return `${minutes} دقیقه باقی‌مانده`;
        }
      }
    },
    resetfilter() {
      this.tableProps = {
        search: "",
        length: 10,
        column: "id",
        dir: "desc",
        page: 1,
        type: null,
      };

      this.fetch();
    },
    applyClearSearch() {
      this.localSearch = "";
      this.tableProps.search = "";
      this.tableProps.page = 1;
      this.fetch();
    },
    applySearch() {
      this.tableProps.page = 1;
      this.fetch();
    },
    action(data, action) {
      this[`${action}Action`](data);
    },
    buyAction(assistant) {
      this.currentPackage = assistant;
      this.selectedAssistantId = assistant.id;
      this.selectedAssistantData = assistant;
      this.showUpgradeDialog = true;
    },
    async connectionAction(assistant) {
      this.selectedAssistantId = assistant.id;
      this.selectedAssistantData = assistant;

      if (assistant.link) {
        this.showlink = true;
        return;
      }

      try {
        this.loading = true;

        if (!assistant.uniq_key) {
          await this.$api.post(`${this.$aiApi}/assistant/design`, {
            assistantId: assistant.id,
            design: {
              config: {
                assistantId: assistant.id,
                assistant: assistant,
                chatSettings: {
                  headerColor: "#667eea",
                  headerColor2: "#764ba2",
                  headerGradient: true,
                  backGrandient: true,
                  backColor: "#ffffff",
                  backColor2: "#ffffff",
                  floatingIcon: "mdi-robot",
                },
                settings: {
                  assistantName: "دستیار هوشمند",
                  assistantDescription:
                    "سلام! من دستیار هوشمند شما هستم. سوال خود را بپرسید",
                },
              },
            },
          });
        }

        const response = await this.$api.get(
          `${this.$aiApi}/assistant/generate/${assistant.id}`,
        );
        const updatedAssistant = this.assistants.data.find(
          (a) => a.id === assistant.id,
        );
        if (updatedAssistant) {
          this.selectedAssistantData = updatedAssistant;
        }
        this.selectedAssistantData.link ?? response.data.link.link;

        if (response.status === 200) {
          this.$toast.success("صفحه چت با موفقیت ساخته شد");

          await this.fetch();

          const updatedAssistant = this.assistants.data.find(
            (a) => a.id === assistant.id,
          );
          if (updatedAssistant) {
            this.selectedAssistantData = updatedAssistant;
            console.log(updatedAssistant, "updatedAssistant");
            this.selectedAssistantData.link =
              this.selectedAssistantData.link ?? response.data.link.link;
          }

          this.showlink = true;
        }
      } catch (error) {
        console.error(error);
        this.$toast.error("خطا در ایجاد اتصال دستیار");
      } finally {
        this.loading = false;
        this.$forceUpdate();
      }
    },
    edit_designAction(assistant) {
      this.selectedAssistantId = assistant.id;

      let designData = assistant.design;

      // if (typeof designData === "string") {
      //   try {
      //     designData = JSON.parse(designData);
      //   } catch (e) {
      //     console.error("خطا در پارس کردن داده‌های دیزاین", e);
      //     designData = null;
      //   }
      // }

      // this.selecteddesign = designData || null;
      // this.editDesign = true;

      // this.$nextTick(() => {
      //   window.scrollTo({ top: 0, behavior: "smooth" });
      // });
      console.log(
        "Navigating to design editor with assistant:",
        assistant.id,
        assistant.uniq_key,
      );
      localStorage.setItem("assisid", assistant.id);

      this.$router.push({
        name: "DesignAssistant",
        params: {
          id: assistant.uniq_key,
          assistantId: assistant.id,
        },
      });
    },
    async disconnectAction(assistant) {
      if (
        await this.$modal.yesNo(
          "آیا از قطع اتصال و حذف لینک این دستیار اطمینان دارید؟ این عملیات قابل بازگشت نیست.",
        )
      ) {
        this.loading = true;
        this.$api
          .delete(`${this.$aiApi}/assistant/link-remove/${assistant.id}`)
          .then(() => {
            this.$toast.success("لینک دستیار با موفقیت قطع شد");
            this.fetch();
          })
          .catch((error) => {
            console.log(error);
            this.$toast.error("خطا درقطع اتصال دستیار");
          })
          .finally(() => (this.loading = false));
      }
    },
    async deleteAction(assistant) {
      this.deletingAssistant = assistant;
      if (
        await this.$modal.error(
          "آیا از حذف این دستیار اطمینان دارید؟ این عملیات قابل بازگشت نیست.",
        )
      ) {
        this.deleteAssistant();
      }
    },
    viewAction(assistant) {
      this.selectedAssistantId = assistant.id;
      this.selectedAssistantData = assistant;
    },
    fetch(props = this.tableProps) {
      this.loading = true;
      if (props.search === "function search() { [native code] }")
        props.search = "";
      this.$api
        .get(`${this.$aiApi}/assistant`, {
          params: {
            search: props.search,
            column: props.column,
            dir: props.dir,
            page: props.page,
            length: props.length,
            // type: props.type,
          },
        })
        .then(({ data }) => {
          console.log("Fetched assistants:", data.data);
          this.assistants = data.data || {};
          console.log(this.assistants, "assistant");
        })
        .catch((data) => {
          console.error("Error fetching assistants:", data);
          const errorMessage =
            err.response?.data?.message ||
            err.message ||
            "خطا در دریافت لیست دستیارها";
          this.$toast.error(errorMessage);
          this.assistants = {};
          this.loading = false;
        })
        .finally(() => (this.loading = false));
    },

    onPagination(e) {
      if (
        e.page !== this.tableProps.page ||
        e.length !== this.tableProps.length ||
        e.search !== this.tableProps.search ||
        e.column !== this.tableProps.column ||
        e.dir !== this.tableProps.dir ||
        e.type !== this.tableProps.type
      ) {
        this.tableProps = {
          ...this.tableProps,
          ...e,
          page: e.page || 1,
          length: e.length || 10,
          search: e.search || "",
          column: e.column || "id",
          dir: e.dir || "desc",
          type: (this.tableProps.type = e.type ?? this.tableProps.type),
        };
        this.$nextTick(() => {
          this.fetch();
        });
      }
    },

    addAssistant() {
      this.editingAssistant = null;
      this.showForm = true;
    },

    backToList() {
      this.showForm = false;
      this.editingAssistant = null;
      this.selectedAssistantData = null;
      this.$nextTick(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        if (!this.assistants || this.assistants.total === 0) {
          this.fetch();
        }
      });
    },
    editAction(assistant) {
      localStorage.setItem("assisid", assistant.id);
      this.$api
        .get(`${this.$aiApi}/assistant/${assistant.id}`)
        .then(({ data }) => {
          this.editingAssistant = data.data.data;
          console.log(this.editingAssistant, "edit assistant");
          this.showForm = true;
        })
        .catch((err) => {
          const errorMessage =
            err.response?.data?.message ||
            err.message ||
            "خطا در دریافت دستیار";
          this.$toast.error(errorMessage);
          this.assistants = {};
          this.loading = false;
        })
        .finally(() => (this.loading = false));
    },

    async deleteAction(assistant) {
      if (
        await this.$modal.yesNo(
          "آیا از حذف این دستیار اطمینان دارید؟ این عملیات قابل بازگشت نیست.",
        )
      ) {
        this.deletingAssistant = assistant;
        this.deleteAssistant();
      }
    },

    deleteAssistant() {
      if (!this.deletingAssistant) return;

      this.loading = true;
      this.$api
        .delete(`${this.$aiApi}/assistant/${this.deletingAssistant.id}`)
        .then(() => {
          this.$toast.success("دستیار با موفقیت حذف شد");
          this.fetch();
          this.deletingAssistant = null;
        })
        .catch((err) => {
          console.error("Error deleting assistant:", err);
          this.$toast.error("خطا در حذف دستیار");
          this.loading = false;
        })
        .finally(() => (this.loading = false));
    },

    handleSaveAssistant(assistantData) {
      this.loading = true;
      let id = this.selectedAssistantId;
      if (this.editingAssistant) {
        if (
          this.selectedAssistantId === null ||
          this.selectedAssistantId === undefined
        ) {
          if (localStorage.getItem("assisid")) {
            id = localStorage.getItem("assisid");
          }
          if (id === null || id === undefined) {
            this.$toast.error(
              "خطایی در ویرایش رخ داده است. لطفا با پشتیبانی تماس بگیرید. ",
            );
            return;
          }
        }
      }

      const method = this.editingAssistant ? "put" : "post";
      const url = this.editingAssistant
        ? `${this.$aiApi}/assistant/${id}`
        : `${this.$aiApi}/assistant`;

      this.$api[method](url, assistantData)
        .then((data) => {
          this.$toast.success(
            this.editingAssistant
              ? "دستیار با موفقیت ویرایش شد"
              : "دستیار با موفقیت ایجاد شد",
          );
          if (data.status === 200) {
            this.$api.post(`${this.$aiApi}/assistant/design`, {
              assistantId: data.data?.data?.id,
              design: {
                config: {
                  assistantId: data.data?.data?.id,
                  assistant: null,
                  hasAssistantsName: false,
                  hasAssistantsFamily: false,
                  hasAssistantsMobile: false,
                  chatSettings: {
                    headerColor: "#667eea",
                    headerColor2: "#764ba2",
                    headerGradient: true,
                    backGrandient: true,
                    backColor: "#ffffff",
                    backColor2: "#CC7D7D",
                    backgroundImage: null,
                    useImageBackground: false,
                    textColor: "#333333",
                    fontSize: 14,
                    chatLogo: null,
                    floatingIcon: "mdi-robot",
                    useImageLogo: false,
                  },
                  settings: {
                    assistantName: "دستیار هوشمند",
                    assistantDescription:
                      " سلام! من دستیار هوشمند شما هستم. سوال خود را بپرسید",
                  },
                },
              },
            });
          }
          this.backToList();
          this.fetch();
        })
        .catch((err) => {
          this.$toast.error("خطا در ذخیره دستیار");
          this.loading = false;
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped>
.direction-ltr {
  direction: ltr !important;
  text-align: left !important;
}

/* استایل باکس لینک */
.link-box {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  transition: all 0.3s ease;
}

.link-box:hover {
  border-color: #6366f1; /* رنگ برند شما */
  background: #ffffff;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.08);
}

.link-text {
  font-family: "monospace", sans-serif;
  font-size: 0.9rem;
  color: #475569;
  letter-spacing: 0.5px;
}

.border-b {
  border-bottom: 1px solid #f1f5f9 !important;
}

.action-btn {
  height: 40px !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-weight: 600;
}

.v-dialog--active {
  backdrop-filter: blur(5px);
}
.close {
  min-width: 36px;
  background-color: rgb(252, 193, 199);
  border-color: rgb(248, 185, 191);
  color: red !important;
  border-radius: 11px !important;
}
</style>
